(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2521],{

/***/ 64778:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./affiliates1.png": 64833,
	"./affiliates2.png": 99294,
	"./article1.png": 94590,
	"./article2.png": 1923
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 64778;

/***/ }),

/***/ 93445:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var map = {
	"./company1.png": 12895,
	"./company10.png": 30236,
	"./company2.png": 83575,
	"./company3.png": 97991,
	"./company4.png": 49993,
	"./company5.png": 47589,
	"./company6.png": 4199,
	"./company7.png": 24069,
	"./company8.png": 11461,
	"./company9.png": 1404,
	"./drive.png": 85233,
	"./dynamics.png": 79216,
	"./highlevel.png": 30196,
	"./hubspot.png": 38179,
	"./make.png": 97789,
	"./pabbly.png": 19704,
	"./pipedrive.png": 21907,
	"./salesforce.png": 12912,
	"./sheets.png": 10378,
	"./slack.png": 75092,
	"./teams.png": 91864,
	"./zapier.png": 19598
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 93445;

/***/ }),

/***/ 5401:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/about",
      function () {
        return __webpack_require__(25753);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 64833:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/affiliates1.c0070cc6.png","height":615,"width":690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAM1BMVEX+5d704NX+7+v7+vjd5M7r5+TP2rz/5+KU2pOk2J3Oy8zi3+nGxcPq4dHf4tPZz+7T0dDOjqjRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAN0lEQVR4nB3IQRKAIBAEsQYWZhZQ/P9rLc0xgGLw0ZUeApW086+0XYDa74gKauvM1YT6ns/uegEgZAE8oolrqQAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 99294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/affiliates2.7641f663.png","height":615,"width":690,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAMFBMVEXY9P7Y8vbm7db9yTrn+PnLzc/l57jr4Jry1m/3+PjExsbX3N3g3uji5sT30FzUzu5ACGK5AAAACXBIWXMAAAsTAAALEwEAmpwYAAAANUlEQVR4nB3ISQ4AIQzEQKeTsMP8/7cj8MkqwIqMm3Z9Y9W9PGl+2qUISQH09eXqwMyRY/IDFB0A3NgNDvgAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 94590:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/article1.6820bc2f.png","height":460,"width":694,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAMFBMVEUSJ0slOFk9U3Q1SWwdMVRZaIEGHUNPZ4hGXYJlfJoDFzwrQGNyiqrAx9KLlKbZ2+SrMHKJAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAK0lEQVR4nAXBhwEAIAzDMKcDyv7/WySQ7VEeNPIkARN/FwVNSpNgWfXRnQ8QkQC4xF0Z1gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 1923:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/article2.ad41d0ad.png","height":458,"width":726,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAFCAMAAABPT11nAAAAHlBMVEXqwgPluwTyzQDuxwHasw/Ooh/XsC3Rr1G9m2O/p50bfbN2AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAKElEQVR4nCXJwQ0AIAwDsQtJW9h/YYTw16zHNgbQNEln6myEFFX9Al0KGABqPGLlSwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":5});

/***/ }),

/***/ 8058:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/hero1.306345df.png","height":540,"width":540,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAKlBMVEX08/T////v7uz9/P3e5OD4+fno2+nu7vLp6enf09/V0Nbt3/2/r6jH4sY/1g1MAAAACXBIWXMAAAdiAAAHYgE4epnbAAAAN0lEQVR4nCXGxw3AQAwEsdEqO/TfrnEwXyQj+jYzfLf+VG2RDk+ERk5WN+BwxSv1iWJGdqIk7QMpYgEWGrmJSgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 79251:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/hero3.1b65818e.png","height":540,"width":540,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAOVBMVEXv7ezh2fvn4fv25fL18v3m4+Ln7O78+Pz18/T////47ufp7vvFpv/i0f/V1dPQtP/P0M/w6P/azvvtlTxZAAAACXBIWXMAAAdiAAAHYgE4epnbAAAAPUlEQVR4nB3GQRKAIAwDwBTapgEU9f+PdXRPC7WGBAXZE9dZgu619uGC3KzNLzOTlYLGCBQE9R78QwdZegFDQAHITC0J7gAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 61695:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/only_solution2.dc5d6071.png","height":540,"width":540,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAPFBMVEX////L9ePm5uv82M72/P/p+OXZ2drT1NTu+f/t6+35+P/2+fTc9PP/4tv47/nm+/K46fr08OHi1v7PvPtQ9mxIAAAACXBIWXMAAAdiAAAHYgE4epnbAAAAO0lEQVR4nAXBBwLAIAgAsRNBhqPr/39tAsOHewLp7mNCvbW3LqW+03vcASmZIsBjZjaBvlprF3A0IpQfPloBn30PHkEAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 12895:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/company1.7ff5524e.png","height":329,"width":758,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAHlBMVEUBAQEBAQEBAQEBAQEBAQEBAQECAgIBAQEBAQECAgKGB/uiAAAACnRSTlNGyn83lpFtqbRe4Z9bOQAAAAlwSFlzAAALEwAACxMBAJqcGAAAACFJREFUeJwFwYcBADAMwjADWf3/4Up4J8CjbiXJpKfc5AMEfgBRazZzxgAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 30236:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/company10.584b1839.png","height":230,"width":692,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAElBMVEVLS0tERERLS0tLS0tJSUlLS0v3pCLwAAAABnRSTlMSAkcmNFZZWaqBAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAHklEQVR4nGNgZmRkZGRgZGRgYWViYmJlYmFgZoAAAAJoACck7w+iAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 83575:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/company2.0eb2e489.png","height":215,"width":1162,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAABCAMAAADU3h9xAAAABlBMVEUpKSkmJia5PHx7AAAAAnRSTlMnNI3ii+gAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAOSURBVHicY2BgZGQAYQAAGwAF8KmiPAAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":1});

/***/ }),

/***/ 97991:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/company3.a71f9191.png","height":290,"width":860,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAFVBMVEUoKCgkJCQoKCgnJycnJycvLy8oKCjyRBJfAAAAB3RSTlNVBStpRg0/86S5ZQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB5JREFUeJxjYGZiYmJgY2ZiYGNjYWZmAAFWRhBgBQADaAA6zUB0wwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 49993:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/company4.885f328e.png","height":187,"width":483,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAHlBMVEUSEhILCwsHBwcICAgJCQkCAgIGBgYJCQkJCQkEBATJD7zCAAAACnRSTlMHElSDcGihN2ffMZvqqAAAAAlwSFlzAAALEwAACxMBAJqcGAAAACBJREFUeJwFwYEBACAIw7B2qMD/D5ugADek6kz2gYrpDwLOADxnvFzlAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 47589:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/company5.01677023.png","height":116,"width":433,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAElBMVEUsLCwmJiZ0dHR3d3eLi4soKCh9EkQuAAAABnRSTlM7R5B5rywX7woYAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGklEQVR4nGNgZmFmYGRlYGBgYmFiYGRgYAQAATgAG5CDescAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 4199:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/company6.3dd0d0ba.png","height":169,"width":900,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAMAAABSSm3fAAAAGFBMVEUkJCQlJSVaWloiIiJaWlpdXV1aWlpMaXFFDmP7AAAACHRSTlMKWmVFkiloAORZBK8AAAAJcEhZcwAACxMAAAsTAQCanBgAAAAaSURBVHicY2BgYGBgZ2VjYmBkZmRkZmJhAQABRQAo3vCVjwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":2});

/***/ }),

/***/ 24069:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/company7.8c39510a.png","height":321,"width":776,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAHlBMVEVISEhHR0dHR0dISEhMTExISEhCQkJISEhNTU1ISEjT8yKTAAAACnRSTlNgSjaKA5cVdCSofldeNAAAAAlwSFlzAAAuIwAALiMBeKU/dgAAACFJREFUeJwFwYcBACAMwzBntMD/DyPRo4pdeGEyAVvy7QcEWgBOHNW2MwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 11461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/company8.289b6052.png","height":289,"width":792,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAGFBMVEUgICAdHR0eHh4eHh4eHh4iIiIfHx8fHx9+DdLHAAAACHRSTlMiCjcvfhpZaTdsKewAAAAJcEhZcwAACxMAAAsTAQCanBgAAAAfSURBVHicBcEHAQAACMOw7gD+HZMQgwlk3W4PSQmaBwMRAD77U/PTAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 1404:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/company9.12e7fbd2.png","height":313,"width":796,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAADCAMAAACZFr56AAAAHlBMVEUFBQUCAgICAgIBAQECAgIEBAQCAgIAAAADAwMCAgKf6N5yAAAACnRSTlMcYFSEmDdtCKos/D99KQAAAAlwSFlzAAALEwAACxMBAJqcGAAAAB9JREFUeJwFwYcBAAAIwrACrv8vNsGkF0CcUzVoYsn9A2YAQwDW3RcAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":3});

/***/ }),

/***/ 85233:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/drive.5276cf40.png","height":119,"width":128,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAHCAMAAAACh/xsAAAAclBMVEX///+Z3LPe9OdMnk0Uevz66an6xChSnv0CrDz+vAMknFf2+vuVvfIYtFXF7s9op+/89+NozJIAkDAAWd9Ztqa47NMAjmmKmQU1q5k3umzA2v3+1W+42v/eqlT/9Mn/+fJCbtThMzD4s7D+jAC7nrj4t2hRgbdbAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nAXBBQKAMAwAsQO2tcPdXf7/RRIgiCMLEGb14Eqg0sn5BXLVznq/0/bjvG7PR9oYY87rJilERN7jB0o0AwpHKa4lAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":7});

/***/ }),

/***/ 79216:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/dynamics.3d100adb.png","height":133,"width":97,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAICAMAAADtGH4KAAAAOVBMVEX////6+/x6janp7fKaqb8KIlk+W4PZ3+fByNVRao8ADkkkPm5gcZX2+PqNnrbK0t3I0Ny3wtEZM2bNI5t4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVR4nAXBiQHAIAgEwVWBA5+Y9N9sZpA1GuSMBBQ+a3DDdhmv66xN1lj+kb36AT0CfiCtATuLkDx1AAAAAElFTkSuQmCC","blurWidth":6,"blurHeight":8});

/***/ }),

/***/ 30196:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/highlevel.875ad758.png","height":131,"width":137,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAZlBMVEX///+Gv/9otv/t4Zz4zTjG86ik46r/8LJ83WFXrP//7pz700f/1kf/9M3c9tXx/PL/++/4+f9q1k3D8Lbu+v/V9r6m0f+z6pv7wQJGzCT64ol20WPN8sOY44dx2VmX0P94wf/73XTSNF8UAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAQElEQVR4nCXGRxKAIBAAwQHBFROCOev/P2mV9KlBGmh7kMV0Pq4HmG0I8w7UmdN5keL+VOWjbIpW9gJeuafx5ANbGwKY970eigAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 38179:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/hubspot.3913b434.png","height":134,"width":125,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAKlBMVEX/////7uH+jzb+mkn+pFv//Pn/8+n+0Kr+sXP+uoL+2Lj+6NX+3MH+wZHgk5lAAAAACXBIWXMAAAsTAAALEwEAmpwYAAAANElEQVR4nBXHyRHAMAwDsSUlW/KR/tvNGD+wNhxBhIgG1OcrgJH2Bqbn9btrJYzqTIFCwA8bnADK88AgCQAAAABJRU5ErkJggg==","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 97789:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/make.c0269e59.png","height":111,"width":146,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAATlBMVEX/////z//Ni/D91P6OKtqgU976AP3Koe33Y/yYUNyKHtjDiOvas/OZH9/s1/nmwfj79v7/mP+yeeTnq/jty/pzFM7doPXIEe/HWu/YDfQtM3wuAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAOUlEQVR4nBXISRKAIAwAwVECCQZEwfX/H7XsYwPjUO0K4X4knxnsvcSXyJSs1CIRS8Hr+s9OmzfXDzIwAclo+GM1AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 19704:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/pabbly.1fed3ed3.png","height":135,"width":138,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAM1BMVEX9//5iyp6X2r9ZxpkfsXPS7uK55dKp4skMrGhvzqY0uYDo9fDv+fWG1rQ7vIU2u4P0+/iBttKMAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nBXLyRHAIAwAsQV8G0L6rzYT/QWvr+UAQ+aRBA9VtXDGbXlaklWYWiSz2maFs49KRP5t53D4ADSKAX3zX5wTAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 21907:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/pipedrive.6b6cd811.png","height":116,"width":118,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAANlBMVEX9/v6828qhzbUAcS4kilKZyK6r0rxwso0AaCFMn3FbqH4Oez9eqYA4kV3l8evc7eTX6uDL49YdPtaIAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAPElEQVR4nBXLSxaAIAzAwFD6BRW9/2V93WUxAaTKAEK1dsFIO/JNIzI8X62OZ/gsRobrTmt851y9+boEfjPnAXMX0c0cAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 12912:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/salesforce.64a42f7b.png","height":113,"width":157,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAKlBMVEUBmt4usOX+//9Sv+o4tecSpuKH0/Dl9fwdq+T2/P6s4PVxy+3Z8fqm3vRPLsiRAAAACXBIWXMAAAsTAAALEwEAmpwYAAAALklEQVR4nAXBBwEAMAzDMKd/jz/dSaxzdrUZGyDnUfLwkNCENOlUAlGNtftdZh8Y6gDZyxlYzwAAAABJRU5ErkJggg==","blurWidth":8,"blurHeight":6});

/***/ }),

/***/ 10378:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/sheets.39e1aa54.png","height":135,"width":122,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAcAAAAICAMAAAAC2hU0AAAAMFBMVEUbomHe8ugnpmk7rHaHy6puxJoMmlX////t+PPH6NhgvpB1xp/Y7uSj1Ly95NHI59g1CVtUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAM0lEQVR4nEXFtwHAMAzAMKrL/f9vMwYL6JjzViGQaxeioLYRzCwfgh/X8Z9qmoP2iFj9ASUtASMpAeA9AAAAAElFTkSuQmCC","blurWidth":7,"blurHeight":8});

/***/ }),

/***/ 75092:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/slack.ba16879b.png","height":130,"width":131,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAS1BMVEX///+g38X00YPvvEn3142K17j44J6Y5Pv0mLPxiKx70rFBvYnjMGxdx5lL0PWn5fjtdZnoVoLywVbtapF22Pli0fJd0fP0wFXpVYFHvQDqAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nB3LRxKAMAwAsXWa41Q6/P+lDOguQFUiHz16BeZ1aq8S0TFUYinkPVu6t4AtT0veO2BtIfwrW3LwAkPyAdM3bWVTAAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 91864:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/teams.32de700d.png","height":136,"width":141,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAVFBMVEX///+BiNCboN2YnNWJj9hhaMuIjt5qccrk5fdCSbWnrPP6+v9MU7OkqeK8wPfKzfJ7hO96gM7t7v1faOWztuc4PqVOV85rc9qCivHV2PhLVc2aoPGhwqt4AAAACXBIWXMAAAsTAAALEwEAmpwYAAAAP0lEQVR4nB3BhQ3AMBAAsQt+GMqw/56VagMsPfNLa6sbWlnng63INNEmrxFR0Y3DIbHscj1CCKacw3cgt/eGD0ZgAj9cHdA4AAAAAElFTkSuQmCC","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 19598:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony default export */ __webpack_exports__["default"] = ({"src":"/_next/static/media/zapier.bc9692d0.png","height":127,"width":130,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAICAMAAADz0U65AAAAJFBMVEX/////zbj/tpj/YiL/rYz/WBb/k2b/iFj/nH7/ckj/2Mj/w6mzyv9OAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAL0lEQVR4nEWLSQoAIBDD0lnV/z9YhAF7CiQFMPFW2ssCiHRPgbUf89JA66sfz/0CGVEAsto3Q+IAAAAASUVORK5CYII=","blurWidth":8,"blurHeight":8});

/***/ }),

/***/ 18954:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(43138);





const BlogCard = (param)=>{
    let { blogImage , image , imageURL , imageWidth ="w-full md:h-[250px] lg:h-[367px] xl:h-[370px]" , title , genre , date , owner , desc , blogUrl , genreColor , customTitle , imageBorders , localAsset =false  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
        href: blogUrl,
        target: "_blank",
        className: "group w-full flex flex-col gap-6 text-center",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "w-full flex items-center justify-center mx-auto",
                children: [
                    (imageURL || image) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[367px] bg-surface-light ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: imageURL ? imageURL : localAsset ? __webpack_require__(64778)("./".concat(image)) : "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_4__.BASE_ASSETS_URL, "/v2/articles/").concat(image),
                            alt: title,
                            width: 100,
                            height: 100,
                            className: "w-full h-full object-cover"
                        })
                    }),
                    blogImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "w-full h-[367px] bg-surface-light ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "".concat(blogImage),
                            alt: title,
                            width: 100,
                            height: 100,
                            className: "w-full h-full object-cover"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "text-left font-bold md:px-0 px-2 ".concat(customTitle ? customTitle : "text-xl leading-snug lg:text-[28px] md:leading-[36px]"),
                children: title
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "md:px-0 px-2",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-left md:text-[22px] md:leading-[32px] text-base leading-snug font-medium text-gray-600",
                        children: desc
                    }),
                    owner && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex justify-start items-center gap-2 mt-8",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                width: 48,
                                height: 48,
                                src: owner === null || owner === void 0 ? void 0 : owner.img,
                                alt: "Owner",
                                className: "rounded-full"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                className: "flex flex-col items-start",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                        className: "md:text-xl text-base font-semibold text-gray-800",
                                        children: owner === null || owner === void 0 ? void 0 : owner.name
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                        className: "md:text-base text-sm font-semibold text-gray-500",
                                        children: owner === null || owner === void 0 ? void 0 : owner.title
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (BlogCard);


/***/ }),

/***/ 2238:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43138);




const CardWithImage = (param)=>{
    let { image , title , description , cardsStyling =""  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "flex-1 w-full border-2 border-gray-800 flex flex-col gap-6 px-6 sm:px-8 pb-8 pt-8 rounded-xl transition-all duration-500 ease-in-out text-center imageBorders",
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex items-center justify-center mx-auto w-full",
                children: image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "h-full w-full bg-white rounded-full",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                        src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_3__.BASE_ASSETS_URL, "/v2/landing-page/").concat(image),
                        alt: title,
                        width: 100,
                        height: 100,
                        className: "w-full h-auto rounded-xl"
                    })
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "flex flex-col gap-4 sm:px-10",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                        className: "text-2xl font-bold",
                        children: title
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-xl",
                        children: description
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CardWithImage);


/***/ }),

/***/ 6716:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);



const MiniCards = (param)=>{
    let { cardsData , cardsStyling ="flex flex-col gap-10"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat(cardsStyling && cardsStyling),
        children: cardsData.map((card, index)=>{
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-[537px] flex flex-col xs:flex-row sm:flex-col lg:flex-row gap-2 sm:gap-4 border px-4 sm:px-6 lg:px-8 py-6 lg:py-4 rounded-xl cardBorders transition-all duration-500 ease-in-out hover:bg-gray-100",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "w-10 flex items-center justify-center ",
                        children: [
                            card.icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-5xl lg:text-4xl flex justify-center items-center h-full w-full",
                                children: card.icon
                            }),
                            card.image && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                src: card.image,
                                width: 10,
                                height: 10,
                                className: "w-full",
                                alt: "hero"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "flex-1 flex flex-col sm:gap-2",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                className: "text-xl lg:text-2xl font-bold",
                                children: card.title
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                                className: "text-lg lg:text-xl",
                                children: card.description
                            })
                        ]
                    })
                ]
            }, index);
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (MiniCards);


/***/ }),

/***/ 61325:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
const _interopRequireDefault = (__webpack_require__(92648)/* ["default"] */ .Z);
const _interopRequireWildcard = (__webpack_require__(91598)/* ["default"] */ .Z);
const _jsxRuntime = __webpack_require__(85893);
const _react = /*#__PURE__*/ _interopRequireWildcard(__webpack_require__(67294));
const _image = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(25675));
const _certifications = /*#__PURE__*/ _interopRequireDefault(__webpack_require__(30501));
const BasicChip = (param)=>{
    let { icon , text , images  } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-[280px] px-3 py-4 flex items-center justify-between gap-3 bg-white rounded-lg moveUpObject",
        children: [
            icon && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bg-orange-400 w-[50px] h-[50px] rounded-full flex justify-center items-center text-3xl text-gray-700",
                children: icon
            }),
            text && /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                className: "text-sm flex-1 text-gray-800",
                children: text
            }),
            images && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "mx-auto",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_certifications.default, {
                    displayText: true,
                    certifications: images,
                    customStyling: "w-full gap-4"
                })
            })
        ]
    });
};
const ChipWithImage = (param)=>{
    let { image , title , description  } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "w-[340px] px-4 py-6 flex items-center justify-between gap-3 bg-white rounded-lg border border-gray-800",
        children: [
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "bg-gray-100 w-[80px] h-[80px] rounded-lg flex justify-center items-center",
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)(_image.default, {
                    src: __webpack_require__(93445)("./" + image),
                    alt: title,
                    width: 50,
                    height: 50,
                    className: "w-full p-2 removeBg"
                })
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
                className: "flex-1 flex flex-col gap-1",
                children: [
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("h4", {
                        className: "text-2xl",
                        children: title
                    }),
                    /*#__PURE__*/ (0, _jsxRuntime.jsx)("p", {
                        className: "text-sm flex-1 text-gray-800",
                        children: description
                    })
                ]
            })
        ]
    });
};
const MiniNavbar = (param)=>{
    let { navItems  } = param;
    return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
        className: "flex flex-wrap justify-center items-center gap-y-2 gap-x-4 sm:gap-16 border border-gray-600 py-4 rounded-full",
        children: navItems.map((item, index)=>{
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "text-md sm:text-xl flex items-center gap-2 cursor-pointer ".concat(item.active ? "text-violet-500" : "text-gray-800"),
                children: item.text
            }, index);
        })
    });
};
const Switch = (param)=>{
    let { switch1 , switch2 , onChangeTab  } = param;
    const [isChecked, setIsChecked] = (0, _react.useState)(true);
    const handleToggle = ()=>{
        setIsChecked(!isChecked);
        onChangeTab();
    };
    return /*#__PURE__*/ (0, _jsxRuntime.jsxs)("div", {
        className: "flex items-center gap-4 text-lg sm:text-xl",
        children: [
            switch1 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: switch1
            }),
            /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "w-16 h-8 flex items-center bg-black rounded-full p-1 cursor-pointer transition-colors duration-300 ".concat(isChecked ? "bg-black" : "bg-black"),
                onClick: handleToggle,
                children: /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                    className: "bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ".concat(isChecked ? "translate-x-8" : "translate-x-0")
                })
            }),
            switch2 && /*#__PURE__*/ (0, _jsxRuntime.jsx)("div", {
                className: "",
                children: switch2
            })
        ]
    });
};
module.exports = {
    BasicChip,
    MiniNavbar,
    ChipWithImage,
    Switch
};


/***/ }),

/***/ 24747:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97005);
/* harmony import */ var _components_MiniComponents__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(61325);
/* harmony import */ var _components_MiniComponents__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_components_MiniComponents__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _constants_constants__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(43138);






const Slider = (param)=>{
    let { heading , sliderImagesData , cardsData , styling , direction ="left"  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "w-full h-full flex flex-col gap-10 justify-center items-center overflow-hidden ".concat(styling),
        children: [
            heading && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                className: "px-4 md:px-8 text-2xl md:text-3xl font-bold text-center",
                children: heading
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "max-w-screen-mxl mx-auto",
                children: [
                    sliderImagesData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        gradient: false,
                        gradientColor: "#fee2e2bf",
                        speed: 50,
                        className: "bg-transparent h-[80px]",
                        children: sliderImagesData === null || sliderImagesData === void 0 ? void 0 : sliderImagesData.map((image, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-8 sm:mx-12",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                    src: "".concat(_constants_constants__WEBPACK_IMPORTED_MODULE_5__.BASE_ASSETS_URL, "/v2/marquee/").concat(image),
                                    width: 150,
                                    height: 100,
                                    alt: "customer",
                                    className: "h-auto"
                                })
                            }, index))
                    }),
                    cardsData && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_fast_marquee__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        gradient: false,
                        direction: direction ? direction : "left",
                        gradientColor: "#fee2e2bf",
                        speed: 50,
                        className: "bg-transparent h-fit",
                        children: cardsData.map((card, index)=>/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "mx-4",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_MiniComponents__WEBPACK_IMPORTED_MODULE_4__.ChipWithImage, {
                                    ...card
                                })
                            }, index))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Slider);


/***/ }),

/***/ 18034:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59183);
/* harmony import */ var _components_Buttons__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(46687);
/* harmony import */ var _utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(10447);






const Subscribe = (param)=>{
    let { heading ="Simple and Budget-Friendly Signing for Your Business" , paragraph ="One fixed price for unlimited signatures, templates, forms, and contracts—no extra charges for adding users and more signatures."  } = param;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "py-20 lg:py-40 mx-auto px-4 md:px-8 xxl:px-0",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "max-w-screen-mxl mx-auto flex flex-col lg:flex-row gap-10",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "flex-1",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                            heading2: heading,
                            paragraph: paragraph
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "flex flex-col sm:flex-row gap-6",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_CTA_CtaOne__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                buttonPrimaryText: "Get Started",
                                buttonPrimaryUrl: "https://signature.boloforms.com/register?from=WEBSITE_BOTTOM_BUTTON".concat((0,_utils_signature_owner__WEBPACK_IMPORTED_MODULE_5__/* .createUTMQueryParams */ .T0)({
                                    from: "WEBSITE_BOTTOM_BUTTON"
                                }))
                            })
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "w-full h-[500px] lg:h-auto lg:flex-1 relative",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: __webpack_require__(8058),
                            width: 10,
                            height: 10,
                            className: "moveRightAndCenterObject rounded-lg w-auto h-[50%] xs:h-[50%] sm:h-[70%] xl:h-[80%] imageBorders absolute left-[10%] top-1/2 z-10",
                            alt: "hero"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: __webpack_require__(61695),
                            width: 10,
                            height: 10,
                            className: "moveCornerLeftRotateLeftObject rounded-lg w-auto h-[30%] xs:h-[40%] sm:h-[50%] lg:h-[40%] xl:h-[65%] imageBorders absolute right-[5%] sm:right-[15%] md:right-[20%] xxl:right-[15%] top-0 lg:top-[-10%] z-10",
                            alt: "hero"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: __webpack_require__(79251),
                            width: 10,
                            height: 10,
                            className: "moveCornerLeftRotateRightObject rounded-lg w-auto h-[40%] xs:h-[50%] sm:h-[60%] lg:h-[50%] xl:h-[70%] imageBorders absolute right-[10%] sm:right-[30%] xxl:right-[20%] bottom-0 xl:bottom-[-20%] z-10",
                            alt: "hero"
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Subscribe);


/***/ }),

/***/ 25753:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ about; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
var image_default = /*#__PURE__*/__webpack_require__.n(next_image);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./components/v2/CTA/CtaOne.jsx
var CtaOne = __webpack_require__(59183);
// EXTERNAL MODULE: ./constants/constants.js
var constants = __webpack_require__(43138);
;// CONCATENATED MODULE: ./components/v2/Cards/DataCard.jsx


const DataCard = (param)=>{
    let { heading , subHeading  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "bg-surface-light flex flex-col justify-center items-center text-center gap-2 rounded-xl p-12",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                className: "text-5xl font-semibold",
                children: heading
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                className: "text-gray-700 text-2xl",
                children: subHeading
            })
        ]
    });
};
/* harmony default export */ var Cards_DataCard = (DataCard);

// EXTERNAL MODULE: ./components/v2/Cards/CardWithImage.jsx
var CardWithImage = __webpack_require__(2238);
// EXTERNAL MODULE: ./components/v2/Slider/index.jsx
var Slider = __webpack_require__(24747);
// EXTERNAL MODULE: ./components/v2/Cards/MiniCards.jsx
var MiniCards = __webpack_require__(6716);
// EXTERNAL MODULE: ./components/v2/Cards/ClientsTestimonial.jsx
var ClientsTestimonial = __webpack_require__(59471);
// EXTERNAL MODULE: ./components/v2/MiniComponents/index.jsx
var MiniComponents = __webpack_require__(61325);
// EXTERNAL MODULE: ./node_modules/react-icons/io/index.esm.js
var index_esm = __webpack_require__(51649);
// EXTERNAL MODULE: ./node_modules/react-icons/md/index.esm.js
var md_index_esm = __webpack_require__(5434);
// EXTERNAL MODULE: ./node_modules/react-icons/io5/index.esm.js
var io5_index_esm = __webpack_require__(60155);
// EXTERNAL MODULE: ./components/v2/Blog/BlogCard.jsx
var BlogCard = __webpack_require__(18954);
// EXTERNAL MODULE: ./components/v2/Subscribe/index.jsx
var Subscribe = __webpack_require__(18034);
;// CONCATENATED MODULE: ./components/v2/Cards/ProfileCard.jsx





const ProfileCard = (param)=>{
    let { name , role , socialLinks , image , bgColor  } = param;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full flex flex-col gap-8 border border-surface-dark rounded-2xl transition-all duration-500 ease-in-out overflow-hidden bg-white",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full aspect-square  bg-surface-dark",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                    src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/about/our_team/").concat(image),
                    width: 10,
                    height: 10,
                    alt: name,
                    loading: "lazy",
                    className: "w-full h-full object-cover"
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "flex flex-col justify-center items-center text-center gap-2 pb-6 px-6",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-2xl font-bold",
                        children: name
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                        className: "text-gray-600 text-lg font-semibold",
                        children: role
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "flex justify-center items-center gap-4",
                        children: socialLinks.map((socialLink, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                href: "".concat(socialLink.link),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "text-md bg-white hover:bg-black text-gray-800 hover:text-white w-[30px] h-[30px] border border-gray-700 rounded-full grid place-items-center transition-all duration-500",
                                    children: socialLink.icon
                                })
                            }, index))
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var Cards_ProfileCard = (ProfileCard);

// EXTERNAL MODULE: ./node_modules/react-icons/fa6/index.esm.js
var fa6_index_esm = __webpack_require__(70231);
;// CONCATENATED MODULE: ./constants/teamData.js






const teamData = [
    {
        name: "Paresh Deshmukh",
        role: "Co-Founder & CEO",
        image: "Paresh-Deshmukh.png",
        bgColor: "bg-green-100",
        socialLinks: [
            {
                platform: "twitter",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa6_index_esm/* FaXTwitter */.LCd, {}),
                link: "https://x.com/pareshmukh"
            }
        ]
    },
    {
        name: "Chirag Gupta",
        role: "Co Founder & CTO",
        image: "Chirag-Gupta.png",
        bgColor: "bg-red-100",
        socialLinks: [
            {
                platform: "twitter",
                icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(fa6_index_esm/* FaXTwitter */.LCd, {}),
                link: "https://x.com/chigup36"
            }
        ]
    },
    {
        name: "Ayush Bobale",
        role: "Senior Full Stack Developer",
        image: "Ayush-Bobale.png",
        bgColor: "bg-blue-100",
        socialLinks: []
    },
    {
        name: "Jenefa Regina Mary",
        role: "Business Development",
        image: "Jenefa-Regina-Mary.png",
        bgColor: "bg-lime-100",
        socialLinks: []
    },
    {
        name: "Ishika Pippal",
        role: "Business Development",
        image: "Ishika-Pippal.png",
        bgColor: "bg-lime-100",
        socialLinks: []
    },
    {
        name: "Rida Ahsan",
        role: "Business Development",
        image: "Rida-Ahsan.png",
        bgColor: "bg-green-100",
        socialLinks: []
    },
    {
        name: "Arian Shaikh",
        role: "Full Stack Developer",
        image: "Arian-Shaikh.png",
        bgColor: "bg-green-100",
        socialLinks: []
    },
    {
        name: "Rahul Batra",
        role: "Full Stack developer",
        image: "Rahul-Batra.png",
        bgColor: "bg-violet-100",
        socialLinks: []
    },
    {
        name: "Yash Kumar Saini",
        role: "Full Stack Developer",
        image: "Yash-Kumar-Saini.png",
        bgColor: "bg-yellow-100",
        socialLinks: []
    },
    {
        name: "Satyam Raj",
        role: "Full Stack Developer",
        image: "Satyam-Raj.png",
        bgColor: "bg-slate-100",
        socialLinks: []
    },
    {
        name: "Firoz Akhter",
        role: "Full Stack developer",
        image: "Firoz-Akhter.png",
        bgColor: "bg-violet-100",
        socialLinks: []
    },
    {
        name: "Roshan (Ross)",
        role: "Senior Customer Success Executive",
        image: "Roshan.png",
        bgColor: "bg-green-100",
        socialLinks: []
    }
];

// EXTERNAL MODULE: ./utils/signature_owner.js
var signature_owner = __webpack_require__(10447);
// EXTERNAL MODULE: ./node_modules/react-icons/tb/index.esm.js
var tb_index_esm = __webpack_require__(37106);
// EXTERNAL MODULE: ./node_modules/react-icons/ai/index.esm.js
var ai_index_esm = __webpack_require__(8193);
// EXTERNAL MODULE: ./node_modules/react-icons/go/index.esm.js
var go_index_esm = __webpack_require__(66653);
// EXTERNAL MODULE: ./node_modules/react-icons/pi/index.esm.js
var pi_index_esm = __webpack_require__(96225);
// EXTERNAL MODULE: ./node_modules/lucide-react/dist/esm/icons/arrow-right.js
var arrow_right = __webpack_require__(82701);
;// CONCATENATED MODULE: ./pages/about/index.jsx



























const cardData = [
    {
        heading: "300k+",
        subHeading: "Our Global Client"
    },
    {
        heading: "15Y+",
        subHeading: "Total Experience"
    },
    {
        heading: "15+",
        subHeading: "Passionate People"
    },
    {
        heading: "99%",
        subHeading: "Customer Satisfaction"
    }
];
const whyChooseData = [
    {
        title: "Create Signature Forms",
        description: "Easily add signature fields to your forms using our intuitive form editor. Save time managing 100s of signatures without the hassle of creating individual documents.",
        image: "choose1.png"
    },
    {
        title: "Team up, without thinking about cost",
        description: "Even if we are a platform for small businesses to take e-signatures, we have enterprise-grade security to protect your contracts from potential threats and ensure compliance with international and industry-specific eSignature laws.",
        image: "choose2.png"
    },
    {
        title: "PDF templates for repeating contracts",
        description: "When you have a contract that is 95% the same but has some minor changes to be made to send to every new person, avoid the redundancy of recreating and remapping signature fields, customize minor details, and send to new recipients efficiently.",
        image: "choose3.png"
    }
];
const customerImages = (/* unused pure expression or super */ null && ([
    "company1.png",
    "company2.png",
    "company3.png",
    "company4.png",
    "company5.png",
    "company6.png",
    "company7.png"
]));
const miniCardsData = [
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(index_esm/* IoMdRepeat */.hkg, {}),
        title: "Streamline Repetitive Operations",
        description: "Save time by automating routine tasks for scaling your small business."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(io5_index_esm/* IoRocketOutline */.wkh, {}),
        title: "Accelerate Decision Making",
        description: "Speed up your business contracts for quicker decisions and enhanced agility."
    },
    {
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(md_index_esm/* MdOutlineGroups */.snE, {}),
        title: "Enhance Team Collaboration",
        description: "Facilitate better teamwork with features designed for easy collaboration."
    }
];
const values = [
    {
        icon: md_index_esm/* MdOutlineSecurity */.AXp,
        title: "Security is non-negotiable",
        description: "We deal with sensitive data. Security, compliance, and reliability aren’t features, they’re our foundation."
    },
    {
        icon: tb_index_esm/* TbUserHeart */.LoC,
        title: "Customer first",
        description: "We win when our customers win. We listen closely, solve real problems, and evolve with your needs."
    },
    {
        icon: ai_index_esm/* AiOutlineThunderbolt */.xtp,
        title: "Speed over perfection",
        description: "Fast, focused execution beats overthinking. We ship, learn, and improve—on repeat."
    },
    {
        icon: io5_index_esm/* IoMedalOutline */.siz,
        title: "Raise the standard",
        description: "We challenge ourselves to exceed what’s expected. We keep learning, pushing ourselves, and striving to exceed even our own highest standards of quality."
    },
    {
        icon: go_index_esm/* GoLightBulb */.bLl,
        title: "Act like owners",
        description: "We take responsibility, drive action, and energize everyone around us. Leadership is a habit, not a title."
    },
    {
        icon: pi_index_esm/* PiGlobeLight */.GtW,
        title: "Think long-term, act local",
        description: "We build for the world, but we pay attention to the local context—whether that’s law, language, or people."
    },
    {
        icon: pi_index_esm/* PiUsersThree */.vCP,
        title: "Win as one team",
        description: "We’re in it together. We help each other across roles and departments, because great things happen when no one works in silos."
    }
];
const officeAddresses = [
    {
        location: "Delaware",
        address: "1111B S Governors Ave STE 34146 Dover, DE 19904, U.S.A"
    },
    {
        location: "Dubai",
        address: "001 - 58669, A1 - 3641379065, IFZA Business Park, Dubai Digital Park, Dubai Silicon Oasis, Dubai, U.A.E"
    },
    {
        location: "Pune ",
        address: "201, Sunshine Business Park, PCMC, Pune- 411027, Maharashtra, India "
    }
];
const About = ()=>{
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: "w-full md:mt-20 mt-8",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("title", {
                        children: "BoloSign - AI for Smart Contract Management | About Us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "icon",
                        href: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/Logo.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.region",
                        content: "IN"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "geo.position",
                        content: "22.351115;78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "ICBM",
                        content: "22.351115, 78.667743"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "author",
                        content: "BoloSign"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "publisher",
                        content: "BoloSign "
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "robots",
                        content: "INDEX, FOLLOW, MAX-IMAGE-PREVIEW:LARGE, MAX-SNIPPET:-1, MAX-VIDEO-PREVIEW:-1"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:url",
                        content: "https://www.bolosign.com/about/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:type",
                        content: "website"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:title",
                        content: "BoloSign - AI for Smart Contract Management | About Us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "og:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:card",
                        content: "summary_large_image"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:domain",
                        content: "bolosign.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        property: "twitter:url",
                        content: "https://www.bolosign.com/about/"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:title",
                        content: "BoloSign - AI for Smart Contract Management | About Us"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:description",
                        content: "AI assistant to draft, review, and eSign contracts on autopilot for fastest growing companies."
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("meta", {
                        name: "twitter:image",
                        content: "https://boloforms-internal-images.s3.ap-south-1.amazonaws.com/website/assets/v2/clm/media-viewport.png"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "canonical",
                        href: "https://www.bolosign.com/about/"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "flex flex-col justify-center items-center gap-28 xxl:gap-24 px-4 md:px-8 pb-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "max-w-screen-lg text-center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaOne/* default */.Z, {
                        heading1: "BoloSign - AI for Smart Contract Management",
                        paragraph: "At BoloSign, our dedicated team is passionate about empowering small businesses with secure and user-friendly eSignature solutions. By building strong client relationships and continuously improving our platform, we are driving the future of digital signatures.",
                        paragraphStyling: "max-w-[900px] mx-auto",
                        buttonsStyling: "justify-center",
                        buttonPrimaryText: "Get Started",
                        buttonPrimaryUrl: "https://signature.boloforms.com/register?from=WEBSITE_HERO_BUTTON".concat((0,signature_owner/* createUTMQueryParams */.T0)({
                            from: "WEBSITE_HERO_BUTTON"
                        })),
                        buttonSecondaryText: "Buy Now",
                        buttonSecondaryUrl: "/signature/pricing",
                        newTab: true
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full max-w-screen-xl mx-auto px-4 md:px-8 mb-16 lg:mb-20",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "bg-gradient-to-r bg-dark rounded-2xl p-8 md:p-12 text-center relative overflow-hidden",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute top-0 right-0 w-32 h-32 bg-gradient-to-br from-green-200 to-blue-200 rounded-full opacity-20 -translate-y-16 translate-x-16"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "absolute bottom-0 left-0 w-24 h-24 bg-gradient-to-tr from-purple-200 to-pink-200 rounded-full opacity-20 translate-y-12 -translate-x-12"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "relative z-10",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "flex justify-center mb-6",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "bg-white rounded-xl p-4 shadow-lg border border-gray-100",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                            src: __webpack_require__(26961),
                                            alt: "NVIDIA Logo",
                                            className: "h-12 w-auto object-contain",
                                            width: 48,
                                            height: 48
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                    className: "text-2xl md:text-3xl font-bold text-white mb-4",
                                    children: "Proudly Backed by NVIDIA Inception"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "max-w-4xl mx-auto",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-lg md:text-xl font-semibold text-slate-400 mb-6",
                                            children: "Now, here's what many don't know…"
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("p", {
                                            className: "text-base md:text-lg text-slate-200 leading-relaxed mb-8",
                                            children: [
                                                "BoloSign is part of the",
                                                " ",
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "font-semibold text-green-700",
                                                    children: "NVIDIA Inception Program"
                                                }),
                                                ", the global accelerator for AI-first startups. That membership delivers early access to NVIDIA's AI tools, expert guidance, and a stamp of confidence. It's a powerful signal for our users that you're using tech validated by one of the most respected names in AI."
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "flex justify-center",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                href: "/announcement/nvidia-inception-program",
                                                className: "inline-flex items-center px-8 py-4 bg-gradient-to-r from-green-600 to-slate-800 text-white font-semibold rounded-xl hover:from-green-700 hover:to-slate-700 transition-all duration-300 shadow-lg hover:shadow-xl transform hover:-translate-y-1",
                                                children: [
                                                    "Read Full Announcement",
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(arrow_right/* default */.Z, {
                                                        className: "ml-2 w-5 h-5"
                                                    })
                                                ]
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full max-w-screen-xl mx-auto px-4 md:px-8 grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-6 md:gap-8",
                children: cardData.map((data, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Cards_DataCard, {
                        heading: data.heading,
                        subHeading: data.subHeading
                    }, index))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "max-w-screen-xl mx-auto px-4 md:px-8 pt-20 lg:pt-32 flex flex-col gap",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "max-w-screen-md mx-auto text-center px-4 relative",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CtaOne/* default */.Z, {
                            heading2: "Team Behind BoloSign",
                            // paragraph="We understand that effective for your task management is the cornerstone of productivity and project success."
                            paragraphStyling: "w-full max-w-screen-sm mx-auto"
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 mt-12 sm:mt-28 xl:mt-10 mb-10 w-full",
                        children: teamData.map((team, index)=>/*#__PURE__*/ (0,jsx_runtime.jsx)(Cards_ProfileCard, {
                                ...team
                            }, index))
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: "bg-surface-light py-24",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                        className: "text-center md:text-5xl text-4xl md:px-0 px-4 font-semibold leading-snug mb-12",
                        children: "Our 7 core values"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 max-w-screen-xl md:px-8 px-4 mx-auto relative",
                        children: [
                            values.map((item, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "bg-white rounded-2xl p-6 md:h-[460px] h-auto flex justify-start items-start flex-col col-span-1",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(item.icon, {
                                                    width: 60,
                                                    height: 60,
                                                    className: "text-[54px]"
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "text-[32px] leading-snug font-bold mb-2 min-h-[72px] mt-4",
                                                    children: item.title
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                            className: "text-gray-700 font-medium text-[20px] leading-[28px] mt-4",
                                            children: item.description
                                        })
                                    ]
                                }, index)),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "hidden lg:flex lg:row-start-2 lg:row-span-2 lg:col-start-3 lg:col-span-1 self-end w-full h-full rounded-2xl overflow-hidden bg-white justify-center items-center relative",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                    src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/about/values.png"),
                                    alt: "BoloSign Values",
                                    fill: true,
                                    className: "object-cover"
                                })
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-full pt-24",
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "max-w-screen-xl mx-auto md:px-8 px-4 flex justify-center items-start gap-16 lg:flex-row flex-col-reverse",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "lg:w-2/3 w-full p-4 md:p-0",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)((image_default()), {
                                src: "".concat(constants.BASE_ASSETS_URL, "/v2/clm/about/locations.png"),
                                alt: "hero",
                                width: 100,
                                height: 100,
                                className: "rounded-2xl object-cover w-full h-full"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "lg:w-1/3 w-full p-4 md:p-0",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h1", {
                                    className: "text-5xl font-semibold",
                                    children: "Our Offices"
                                }),
                                officeAddresses === null || officeAddresses === void 0 ? void 0 : officeAddresses.map((address, index)=>/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "".concat(index === 0 ? "mt-8" : " border-t border-gray-300", " py-4 flex justify-start items-start gap-2"),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                className: "w-4 h-4 rounded-full bg-primary mt-2"
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex-1",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                        className: "font-semibold text-[22px] leading-[26px]",
                                                        children: address.location
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                                        className: "text-[18px] leading-[24px] mt-2",
                                                        children: address.address
                                                    })
                                                ]
                                            })
                                        ]
                                    }, index))
                            ]
                        })
                    ]
                })
            })
        ]
    });
};
/* harmony default export */ var about = (About);


/***/ }),

/***/ 97005:
/***/ (function(__unused_webpack_module, exports, __webpack_require__) {

var __webpack_unused_export__;
"use client"


function ___$insertStyle(css) {
    if (!css || typeof window === 'undefined') {
        return;
    }
    const style = document.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    document.head.appendChild(style);
    return css;
}

__webpack_unused_export__ = ({ value: true });

var React = __webpack_require__(67294);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

___$insertStyle(".rfm-marquee-container {\n  overflow-x: hidden;\n  display: flex;\n  flex-direction: row;\n  position: relative;\n  width: var(--width);\n  transform: var(--transform);\n}\n.rfm-marquee-container:hover div {\n  animation-play-state: var(--pause-on-hover);\n}\n.rfm-marquee-container:active div {\n  animation-play-state: var(--pause-on-click);\n}\n\n.rfm-overlay {\n  position: absolute;\n  width: 100%;\n  height: 100%;\n}\n.rfm-overlay::before, .rfm-overlay::after {\n  background: linear-gradient(to right, var(--gradient-color), rgba(255, 255, 255, 0));\n  content: \"\";\n  height: 100%;\n  position: absolute;\n  width: var(--gradient-width);\n  z-index: 2;\n  pointer-events: none;\n  touch-action: none;\n}\n.rfm-overlay::after {\n  right: 0;\n  top: 0;\n  transform: rotateZ(180deg);\n}\n.rfm-overlay::before {\n  left: 0;\n  top: 0;\n}\n\n.rfm-marquee {\n  flex: 0 0 auto;\n  min-width: var(--min-width);\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  animation: scroll var(--duration) linear var(--delay) var(--iteration-count);\n  animation-play-state: var(--play);\n  animation-delay: var(--delay);\n  animation-direction: var(--direction);\n}\n@keyframes scroll {\n  0% {\n    transform: translateX(0%);\n  }\n  100% {\n    transform: translateX(-100%);\n  }\n}\n\n.rfm-initial-child-container {\n  flex: 0 0 auto;\n  display: flex;\n  min-width: auto;\n  flex-direction: row;\n  align-items: center;\n}\n\n.rfm-child {\n  transform: var(--transform);\n}");

const Marquee = React.forwardRef(function Marquee({ style = {}, className = "", autoFill = false, play = true, pauseOnHover = false, pauseOnClick = false, direction = "left", speed = 50, delay = 0, loop = 0, gradient = false, gradientColor = "white", gradientWidth = 200, onFinish, onCycleComplete, onMount, children, }, ref) {
    // React Hooks
    const [containerWidth, setContainerWidth] = React.useState(0);
    const [marqueeWidth, setMarqueeWidth] = React.useState(0);
    const [multiplier, setMultiplier] = React.useState(1);
    const [isMounted, setIsMounted] = React.useState(false);
    const rootRef = React.useRef(null);
    const containerRef = ref || rootRef;
    const marqueeRef = React.useRef(null);
    // Calculate width of container and marquee and set multiplier
    const calculateWidth = React.useCallback(() => {
        if (marqueeRef.current && containerRef.current) {
            const containerRect = containerRef.current.getBoundingClientRect();
            const marqueeRect = marqueeRef.current.getBoundingClientRect();
            let containerWidth = containerRect.width;
            let marqueeWidth = marqueeRect.width;
            // Swap width and height if direction is up or down
            if (direction === "up" || direction === "down") {
                containerWidth = containerRect.height;
                marqueeWidth = marqueeRect.height;
            }
            if (autoFill && containerWidth && marqueeWidth) {
                setMultiplier(marqueeWidth < containerWidth
                    ? Math.ceil(containerWidth / marqueeWidth)
                    : 1);
            }
            else {
                setMultiplier(1);
            }
            setContainerWidth(containerWidth);
            setMarqueeWidth(marqueeWidth);
        }
    }, [autoFill, containerRef, direction]);
    // Calculate width and multiplier on mount and on window resize
    React.useEffect(() => {
        if (!isMounted)
            return;
        calculateWidth();
        if (marqueeRef.current && containerRef.current) {
            const resizeObserver = new ResizeObserver(() => calculateWidth());
            resizeObserver.observe(containerRef.current);
            resizeObserver.observe(marqueeRef.current);
            return () => {
                if (!resizeObserver)
                    return;
                resizeObserver.disconnect();
            };
        }
    }, [calculateWidth, containerRef, isMounted]);
    // Recalculate width when children change
    React.useEffect(() => {
        calculateWidth();
    }, [calculateWidth, children]);
    React.useEffect(() => {
        setIsMounted(true);
    }, []);
    // Runs the onMount callback, if it is a function, when Marquee is mounted.
    React.useEffect(() => {
        if (typeof onMount === "function") {
            onMount();
        }
    }, []);
    // Animation duration
    const duration = React.useMemo(() => {
        if (autoFill) {
            return (marqueeWidth * multiplier) / speed;
        }
        else {
            return marqueeWidth < containerWidth
                ? containerWidth / speed
                : marqueeWidth / speed;
        }
    }, [autoFill, containerWidth, marqueeWidth, multiplier, speed]);
    const containerStyle = React.useMemo(() => (Object.assign(Object.assign({}, style), { ["--pause-on-hover"]: !play || pauseOnHover ? "paused" : "running", ["--pause-on-click"]: !play || (pauseOnHover && !pauseOnClick) || pauseOnClick
            ? "paused"
            : "running", ["--width"]: direction === "up" || direction === "down" ? `100vh` : "100%", ["--transform"]: direction === "up"
            ? "rotate(-90deg)"
            : direction === "down"
                ? "rotate(90deg)"
                : "none" })), [style, play, pauseOnHover, pauseOnClick, direction]);
    const gradientStyle = React.useMemo(() => ({
        ["--gradient-color"]: gradientColor,
        ["--gradient-width"]: typeof gradientWidth === "number"
            ? `${gradientWidth}px`
            : gradientWidth,
    }), [gradientColor, gradientWidth]);
    const marqueeStyle = React.useMemo(() => ({
        ["--play"]: play ? "running" : "paused",
        ["--direction"]: direction === "left" ? "normal" : "reverse",
        ["--duration"]: `${duration}s`,
        ["--delay"]: `${delay}s`,
        ["--iteration-count"]: !!loop ? `${loop}` : "infinite",
        ["--min-width"]: autoFill ? `auto` : "100%",
    }), [play, direction, duration, delay, loop, autoFill]);
    const childStyle = React.useMemo(() => ({
        ["--transform"]: direction === "up"
            ? "rotate(90deg)"
            : direction === "down"
                ? "rotate(-90deg)"
                : "none",
    }), [direction]);
    // Render {multiplier} number of children
    const multiplyChildren = React.useCallback((multiplier) => {
        return [
            ...Array(Number.isFinite(multiplier) && multiplier >= 0 ? multiplier : 0),
        ].map((_, i) => (React__default['default'].createElement(React.Fragment, { key: i }, React.Children.map(children, (child) => {
            return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
        }))));
    }, [childStyle, children]);
    return !isMounted ? null : (React__default['default'].createElement("div", { ref: containerRef, style: containerStyle, className: "rfm-marquee-container " + className },
        gradient && React__default['default'].createElement("div", { style: gradientStyle, className: "rfm-overlay" }),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle, onAnimationIteration: onCycleComplete, onAnimationEnd: onFinish },
            React__default['default'].createElement("div", { className: "rfm-initial-child-container", ref: marqueeRef }, React.Children.map(children, (child) => {
                return (React__default['default'].createElement("div", { style: childStyle, className: "rfm-child" }, child));
            })),
            multiplyChildren(multiplier - 1)),
        React__default['default'].createElement("div", { className: "rfm-marquee", style: marqueeStyle }, multiplyChildren(multiplier))));
});

exports.Z = Marquee;
//# sourceMappingURL=index.js.map


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [4617,3777,7627,9866,8907,9642,9471,9774,2888,179], function() { return __webpack_exec__(5401); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);